import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import ApiResponse from '../../components/message/ApiResponse';
import PlainPage from '../../components/plain/PlainPage';
import FieldString from '../../components/plain/FieldString';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldDatetime from '../../components/plain/FieldDatetime';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldReference from '../../components/plain/FieldReference';

import {FORM_PRODUCT_TABLE} from '../../util/consts/forms';
import {PRODUCT_PLAIN_PATH} from '../../util/routes';
import { 
	performApiRequest, ACTION_EBOOK_REPORT_ITEM_SAVE_API_URL
} from '../../util/restapi'; 
import {formatDateTime} from '../../util/tools';
import {IET_SET_VALUE} from '../../util/realm/instance';

import iconSpin from '../../assets/icons/spinner-snake.gif';

export const FORM_STATE_READY = 'ready';
export const FORM_STATE_SAVING = 'saving';
export const FORM_STATE_SAVING_ERROR = 'savingError';

class EBookReportItemPlainModal extends PlainPage {
	
	readOnly = false;
	saveResponse = null;

	/*
		table
		masterPlain 
		indexBean
		bean 
		supplier 
	*/
	constructor(props) {
		super(props);
		this.formTitle = 'Report item';
		this.isModal = true;
		this.state.itemFormState = FORM_STATE_READY;
		let providerRef = null;
		if( props.supplier ) {
			providerRef = props.supplier.providerRef;
		}
		this.refProductNodes = [
			{
				classId: 'Product', plainFormPath: PRODUCT_PLAIN_PATH, 
				selectInstanceFormId: FORM_PRODUCT_TABLE,
				selectInstanceFormTitle: 'Продукт',
				filtersInitData: [{predicateId: 'provider', value: providerRef}]
			}
		];
	}
	componentDidMount = async () => {
		this.init('EBookReportItem')
		//document.title = 'BOM. ' + this.formTitle;
	}
	completeInit = async () => {
		if( this.instance && this.instance.id == null ) {
			this.instance.rootField.value.dateTime.value = formatDateTime( new Date() );
			let report = this.props.masterPlain.instance;
			this.instance.rootField.value.reportRef.value = {
			 	id: report.id,
				className: report.model.entityId,
				globalId: report.globalId,
				card: '',
			};
		}
		return true;
	}
	handleInstanceChange = async (event) => {
		super.handleInstanceChange(event);
		let field = event.field;
		
		let fieldMid = this.instance.rootField.value.mid;
		if( event.eventType == IET_SET_VALUE && field == fieldMid ) {
			this.setState({
				plainDirtyCounter: this.state.plainDirtyCounter + 1 
			});
		}
	}

	saveItem = async () => {
		this.setState({itemFormState: FORM_STATE_SAVING})

		let bean = this.instance.createBean();
		bean.feVersion = 'plain1';

		this.saveResponse = this.validateBean(bean);
		if( ! this.saveResponse.success ) {
			this.setState({itemFormState: FORM_STATE_SAVING_ERROR});
			return;
		}
		
		let request = {item: bean}
		let response = await performApiRequest(ACTION_EBOOK_REPORT_ITEM_SAVE_API_URL, request);
		if( response.success ) {
			let table = this.props.table;
			table.updateRow(response.item, this.props.indexBean);
			let inst = this.props.masterPlain.instance;
			inst.setFieldValueByPath('/qty', response.reportQty);
			inst.setFieldValueByPath('/amount', response.reportAmount);
			table.closeEditModal();
		} else {
			this.saveResponse = response;
			this.setState({itemFormState: FORM_STATE_SAVING_ERROR})
		}
	}
	validateBean(bean) {
		let response = {success: true, message: '', log: ''};

		let reportInstance = this.props.masterPlain.instance;
		let month = reportInstance.rootField.value.month.value;
		let year = reportInstance.rootField.value.year.value;
		
		if( ! year ) {
			response.log += 'Не визначено значення поля \'Рік\' в звіті\n';
			response.success = false;
		}
		if( ! month ) {
			response.log += 'Не визначено значення поля \'Місяць\' в звіті\n';
			response.success = false;
		}
		if( ! response.success ) {
			response.message = 'Не заповнені необхідні поля в звіті';
			return response;
		}
		
		if( ! bean.productRef ) {
			response.log += 'Не визначено значення поля \'Розповсюджувач\'\n';
			response.success = false;
		}
		if( ! bean.dateTime ) {
			response.log += 'Не визначено значення поля \'Дата,час\'\n';
			response.success = false;
		} else {
			let itemYear = bean.dateTime.getFullYear();
			let itemMonth = bean.dateTime.getMonth() + 1; 
			if( ! (itemYear == year && itemMonth == month) ) {
				response.log += 'Дата рядка звіту не попадає в часовий діапазон самого звіту (рік, місяць)\n';
				response.success = false;
			}
			console.log('year, month', year, month, itemYear, itemMonth);
		}
		if( ! bean.ps ) {
			response.log += 'Не визначено значення поля \'Платіжна система\'\n';
			response.success = false;
		}
		if( ! bean.aid ) {
			response.log += 'Не визначено значення поля \'Еквайр\'\n';
			response.success = false;
		}
		if( ! bean.mid ) {
			response.log += 'Не визначено значення поля \'Мерчант\'\n';
			response.success = false;
		}
		if( ! bean.mcc ) {
			response.log += 'Не визначено значення поля \'МСС\'\n';
			response.success = false;
		}
		if( ! bean.tid ) {
			response.log += 'Не визначено значення поля \'Код термінала\'\n';
			response.success = false;
		}
		if( ! bean.bin ) {
			response.log += 'Не визначено значення поля \'BIN\'\n';
			response.success = false;
		}
		if( ! bean.operation ) {
			response.log += 'Не визначено значення поля \'Операція\'\n';
			response.success = false;
		}
		if( ! bean.qty ) {
			response.log += 'Не визначено значення поля \'Кількість\'\n';
			response.success = false;
		} else if(bean.qty < 0) {
			response.log += 'Значення поля \'Кількість\' не може бути від\'ємним\n';
			response.success = false;
		}
		if( ! bean.price ) {
			response.log += 'Не визначено значення поля \'Сума\'\n';
			response.success = false;
		} else if(bean.price < 0) {
			response.log += 'Значення поля \'Сума\' не може бути від\'ємним\n';
			response.success = false;
		}
		
		if( ! response.success )
			response.message = 'Невірний рядок звіту';
		
		return response;
	}

	renderBody() {
		let instance = this.state.instance;
		let readOnly = this.readOnly;

		let enumerationMids = { id: 'mids', items: [] };
		let midWrongValues = [];
		let enumerationTids = { id: 'tids', items: [] };
		let tidWrongValues = [];
		let supplier = this.props.supplier;
		let mid = instance.rootField.value.mid.value;
		let tid = instance.rootField.value.tid.value;

		if( supplier != null ) {
			for(let m of supplier.merchantWithTerminals) {
				enumerationMids.items.push( {value: m.mid, label: m.mid} )
			}
		}

		if( supplier != null ) {
			for(let m of supplier.merchantWithTerminals) {
				enumerationMids.items.push( {value: m.mid, label: m.mid} )
				if( m.mid == mid ) {
					for(let t of m.terminalList ) {
						enumerationTids.items.push( {value: t.tid, label: t.tid} )
					}
				}
			}
		}
		if( mid ) {
			let valid = false;
			for( let e of enumerationMids.items) {
				if( e.value == mid ) {
					valid = true;
					break;
				}
			}
			if( ! valid ) {
				enumerationMids.items.unshift({value: mid, label: mid});
				midWrongValues.push( mid );
			}
		}
		enumerationMids.items.unshift({value: '', label: ''})

		if( tid ) {
			let valid = false;
			for( let e of enumerationTids.items) {
				if( e.value == tid ) {
					valid = true;
					break;
				}
			}
			if( ! valid ) {
				enumerationTids.items.unshift({value: tid, label: tid});
				tidWrongValues.push( tid );
			}
		}
		enumerationTids.items.unshift({value: '', label: ''});

		return (
			<div className={stylesPlain.divPlainMain}>
				{/* Body */}
				<div style={{padding: '20px'}} >
					<div style={{ display: 'flex', marginTop: '30px',alignItems: 'center'}}>
						<FieldReference instance={instance} path={'/productRef'} plain={this}
							refNodes={this.refProductNodes}
							readOnly={this.readOnly}
							styles={{divMain: {flexGrow: '1',}}}
						/>
					</div>
					<div style={{ display: 'flex', marginTop: '30px',alignItems: 'center'}}>
						<FieldDatetime instance={instance} path={'/dateTime'} plain={this} 
							readOnly={readOnly}
							styleInput={{width: '200px', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/ps'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}}
						/>
						{/*
						<FieldRefList path={'acquirerRef'} instance={instance} plain={plain} readOnly={this.props.readOnly} 
							parentField={fieldGroup} classId={'EBookBank'} styles={{ select: { width: '370px', marginRight: '20px'}}} 
						/>
						*/}
						<FieldString instance={instance} path={'/aid'} plain={this} 
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
							readOnly={readOnly}
						/>
						<FieldEnum instance={instance} path={'/mid'} plain={this} 
							enumeration={enumerationMids} wrongValues={midWrongValues} 
							styles={{ select: {flexGrow: '1',}}}
							readOnly={readOnly}
						/>
{/*
						<FieldString instance={instance} path={'/mid'} plain={this} 
							styles={{ input: {flexGrow: '1',}}}
							readOnly={readOnly}
						/>
*/}
					</div>
					<div style={{ display: 'flex', marginTop: '30px',alignItems: 'center'}}>
						<FieldEnum instance={instance} path={'/mcc'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}}
						/>
{/*
						<FieldString instance={instance} path={'/tid'} plain={this} 
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
							readOnly={readOnly}
						/>
*/}
						<FieldEnum instance={instance} path={'/tid'} plain={this} 
							enumeration={enumerationTids} wrongValues={tidWrongValues}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}}
							readOnly={readOnly}
						/>
						<FieldString instance={instance} path={'/bin'} plain={this} 
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
							readOnly={readOnly}
						/>
						<FieldEnum instance={instance} path={'/operation'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '0'}}}
						/>
					</div>
					<div style={{ display: 'flex', marginTop: '30px', alignItems: 'center'}}>
						<FieldString instance={instance} path={'/tranId'} plain={this} 
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
							readOnly={readOnly}
						/>
						<FieldInteger instance={instance} path={'/qty'} plain={this} 
							readOnly={readOnly}
							styleInput={{width: '60px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldDecimal instance={instance} path={'/price'} plain={this}
							readOnly={readOnly}
							styleInput={{width: '100px', textAlign: 'right',}} 
						/>
					</div>
				</div>
				{this.renderFooter()}
			</div>
		)
	}
	renderFooter() {
		if( this.state.itemFormState == FORM_STATE_READY ) {
			return (
				<div style={{textAlign: 'right', padding: '0 20px 10px 0'}}>
					<button type='button' style={{padding: '3px 20px 3px 20px'}} onClick={this.saveItem}
						title={this.resource.buttonSave}
					>
						{this.resource.buttonSave}
					</button>
				</div>
			)
		}
		if( this.state.itemFormState == FORM_STATE_SAVING) {
			return(
				<div>
					<div style={{marginBottom: '40px', textAlign: 'center'}}>
						<img src={iconSpin} />
					</div>
				</div>
			);
		}
		if( this.state.itemFormState == FORM_STATE_SAVING_ERROR) {
			return(
				<div>
					<ApiResponse response={this.saveResponse} defaultMessage={'Error'}/>
					<div style={{textAlign: 'right', padding: '20px 20px 10px 0'}}>
						<button type='button' style={{padding: '3px 20px 3px 20px'}} 
							onClick={() => {this.setState({itemFormState: FORM_STATE_READY})}}
							title={this.resource.buttonSave}
						>
							{this.resource.buttonResume}
						</button>
					</div>
				</div>
			);
		}
	}
}

export default EBookReportItemPlainModal;
